import { takeLatest, put, all, call } from 'redux-saga/effects';
import highmarkRulesTypes from './high-mark-rules.type';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	addHighmarkRulesFailure,
	addHighmarkRulesResponseChanged,
	addHighmarkRulesSuccess,
	fetchHighmarkRulesFailure,
	fetchHighmarkRulesResponseChanged,
	fetchHighmarkRulesSuccess,
} from './high-mark-rules.action';
import { highmarkRulesAdd, highmarkRulesFetch } from './high-mark-rules.service';

/** *********************  START ADD THRIFT DETAILS  ******************** */
export function* createThrift({ payload }: any) {
	const { companyID, databaseName, ruleArr } = payload;
	try {
		const key = 'UpdateHighmarkRulesKey';
		const HighmarklistJson = JSON.stringify(ruleArr).replace(/"/g, "'");
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			RuleArr: HighmarklistJson,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(highmarkRulesAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addHighmarkRulesFailure(responseData.data));
		} else {
			yield put(addHighmarkRulesSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addHighmarkRulesFailure(error));
	}
}

export function* resetAddThriftResponse() {
	yield put(addHighmarkRulesResponseChanged());
}

export function* onCreateHighmarkRules() {
	yield takeLatest(highmarkRulesTypes.ADD_HIGHMARK_RULES_START, createThrift);
}

export function* onCreateThriftResponseReset() {
	yield takeLatest(highmarkRulesTypes.ADD_HIGHMARK_RULES_RESPONSE_RESET, resetAddThriftResponse);
}
/** *********************  END ADD THRIFT DETAILS ******************** */

/** *********************  START FETCH THRIFT DETAILS  ******************** */
export function* fetchThriftData({ payload }: any) {
	const { companyID, databaseName } = payload;
	try {
		const key = 'FetchHighmarkRulesKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(highmarkRulesFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchHighmarkRulesFailure(responseData.data));
		} else {
			yield put(fetchHighmarkRulesSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchHighmarkRulesFailure(error));
	}
}

export function* resetFetchHighmarkRulesResponse() {
	yield put(fetchHighmarkRulesResponseChanged());
}

export function* onFetchHighmarkRules() {
	yield takeLatest(highmarkRulesTypes.FETCH_HIGHMARK_RULES_START, fetchThriftData);
}

export function* onFetchThriftResponseReset() {
	yield takeLatest(
		highmarkRulesTypes.FETCH_HIGHMARK_RULES_RESPONSE_RESET,
		resetFetchHighmarkRulesResponse,
	);
}
/** *********************  END FETCH THRIFT DETAILS ******************** */

export function* highmarkRulesSaga() {
	yield all([
		call(onCreateHighmarkRules),
		call(onCreateThriftResponseReset),
		call(onFetchHighmarkRules),
		call(onFetchThriftResponseReset),
	]);
}
